import Slideshow from "../../classes/Slideshow";
import {Lightbox} from "../../classes/Lightbox";

export const initSectionComplexCard = () => {
	const components = Array.from( document.querySelectorAll(`section.complex-card`));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			const slider = component.querySelector(`div.slideshow`);
			const bookletSelect = component.querySelector(`li.booklet a:not([href])`);
			
			if ( slider )
			{
				const bookmarksContainer = slider.querySelector(`ul.buttons`);
				const slidesContainer = slider.querySelector(`ul.slides`);
				const navsContainer = slider.querySelector(`ul.nav`);

				if ( bookmarksContainer || navsContainer)
				{
					new Slideshow({
						slidesContainer,
						bookmarksContainer,
						navsContainer,
						loop: true,
						autoPlay: true,
					});
				}
			}
			
			if ( bookletSelect )
			{
				const bookletParent = bookletSelect.parentNode;
				
				const closeSelect = ( evt ) => {
					if ( evt.target.closest( `li.booklet` ) !== bookletParent )
					{
						evt.preventDefault();
					}

					bookletParent.classList.toggle(`show-select`);
					document.removeEventListener(`click`, closeSelect );
				};
				
				bookletSelect.addEventListener(`click`, ( evt ) => {
					if ( !bookletParent.classList.contains(`show-select`) )
					{
						bookletParent.classList.toggle(`show-select`);
						
						if ( window.innerWidth >= 636 )
						{
							evt.stopPropagation();
							document.addEventListener(`click`, closeSelect );
						} else
						{
							Lightbox.open( bookletParent.querySelector(`ul`), () => bookletParent.classList.remove(`show-select`), `tooltip` );
							
							const contentWrapper = Lightbox.getLightbox().querySelector(`div.wrapper`);
							let wasStarted = false;
							let isDetecting = false;
							let startX;
							let moveX;
							let prevShiftY;
							let shiftY;
							let startY;
							let moveY;
							
							const moveWrapper = ( moveEvt ) => {
								if ( !wasStarted && !isDetecting )
								{
									return;
								}

								moveX = moveEvt.touches[0].clientX;
								moveY = moveEvt.touches[0].clientY;

								if ( isDetecting )
								{
									if ( Math.abs(startX - moveX) <= Math.abs(startY - moveY) )
									{
										moveEvt.preventDefault();

										wasStarted = true;
									}

									isDetecting = false;
								}

								if ( wasStarted )
								{
									moveEvt.preventDefault();

									prevShiftY = shiftY;
									shiftY = (moveY - startY) * 100 / contentWrapper.offsetHeight;
									contentWrapper.style.transition = `none`;
									contentWrapper.style.transform = `translateY(${shiftY < 0 ? 0 : shiftY}%)`;
								}
							};
							const endMoveWrapper = ( endEvt ) => {
								if ( !wasStarted || isDetecting )
								{
									return isDetecting = false;
								}

								endEvt.preventDefault();
								wasStarted = false;

								contentWrapper.style.transition = ``;

								if ( prevShiftY < shiftY )
								{
									contentWrapper.style.transform = `translateY(100%)`;
									Lightbox.close();
								} else
								{
									contentWrapper.style.transform = ``;
								}
							};

							Lightbox.addCloseCallback( () => {
								document.removeEventListener(`touchmove`, moveWrapper);
								document.removeEventListener(`touchend`, endMoveWrapper);
							});
							
							contentWrapper.addEventListener(`touchstart`, ( startEvt ) => {
								if ( wasStarted )
								{
									return;
								}

								isDetecting = true;

								startX = startEvt.touches[0].clientX;
								startY = startEvt.touches[0].clientY;
							});
							document.addEventListener(`touchmove`, moveWrapper, {passive: false});
							document.addEventListener(`touchend`, endMoveWrapper, {passive: false});
						}
					}
				});
			}
		});
	}
};
